import classNames from 'classnames/bind';
import React, { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import { FieldNumber } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const domRefs = useRef({
    servo: useRef(),
    pwm: useRef(),
    count: useRef(),
    time: useRef(),
  }).current;

  useEffect(() => {
    domRefs.servo.current.value = command.data.servo;
    domRefs.pwm.current.value = command.data.pwm;
    domRefs.count.current.value = command.data.count;
    domRefs.time.current.value = command.data.time;
  }, [command.data]);

  const handleBlur = (e) => {
    const name = e.target.name;
    const value = Number(Math.trunc(e.target.value));
    dispatch(actions.mission.updateCommand(index, name, value));
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Servo Instance Number">
        <FieldNumber ref={domRefs.servo} name="servo" min={0} onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Pulse Width Modulation">
        <FieldNumber ref={domRefs.pwm} name="pwm" min={0} onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Cycle Count">
        <FieldNumber ref={domRefs.count} name="count" min={1} onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Cycle Time" unit="secs">
        <FieldNumber ref={domRefs.time} name="time" min={0} onBlur={handleBlur} />
      </FieldRow>
    </div>
  );
};

export default Command;
